import { toast } from 'react-toastify';

export const handleError = (message: string | undefined, time?: number) => {
    const text = message ?? 'Something went wrong.';
    toast.error(text, {
      hideProgressBar: true,
      autoClose: time ?? 5000,
    });
}